import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
// main.js or main.ts
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// H10: the API base URL now comes from VUE_APP_API_BASE_URL (.env /
// .env.production), so environment separation is actually driven by the env
// files instead of a hostname guess baked into the bundle. Falls back to the
// previous hostname-based logic when the var isn't set, so this stays a
// no-op for any setup (e.g. the E2E Playwright config) that doesn't define it.
const isLocalhost = window.location.hostname === "localhost";

axios.defaults.baseURL =
  process.env.VUE_APP_API_BASE_URL ||
  (isLocalhost
    ? "http://localhost:50013/api/" // Localhost API
    : "https://api.stratayourself.com.au/api/"); // Prod API

// Add response interceptor for 401 handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      store.commit("SET_USER_AUTHS", { token: null, isLoggedIn: false });
      router.push("/login");
    }
    return Promise.reject(error);
  },
);

// vue-google-charts loads its script asynchronously; if the <GChart> host
// unmounts (route change, 401 redirect above) before that finishes, the
// library throws on a stale element ref as an unhandled rejection. The
// chart's container is already gone by then, so it's a no-op - swallow only
// this known, harmless race instead of every unhandled rejection.
window.addEventListener("unhandledrejection", (event) => {
  if (event.reason?.message === "please, provide chart element property") {
    event.preventDefault();
  }
});

createApp(App).use(store).use(router).mount("#app");
